import { gql } from "apollo-angular";

export const GET_USER_MENU_ACTIVE_CUSTOMER = gql`
    query GetActiveCustomer {
        activeCustomer {
            id
            firstName
            lastName
            emailAddress
            phoneNumber
            addresses {
                id
                fullName
                company
                streetLine1
                streetLine2
                city
                province
                postalCode
                phoneNumber
                defaultShippingAddress
                defaultBillingAddress
            }
        }
    }
`;